import React, { useState }            from 'react';
import Modal                          from 'react-bootstrap/Modal';
import CloseBtn                       from 'assets/icons/Close.svg';
import MoreButton                     from 'assets/icons/More.svg';
import ArrowDown                      from 'assets/icons/Arrow Down.svg';
import { claimDetailsElements }       from './ClaimDetailsElements';
import { NavLink }                    from 'react-router-dom';

export function ClaimDetails(props) {
  const handleClose       = () => setShow(false);
  const handleShow        = () => setShow(true);
  const [show, setShow]   = useState(false);

  // Delete function
    const [showActions, setShowActions] = useState(false);

    const modalClick = (target) => {
      if (target.id !== 'more-actions-btn' && target.id !== 'arrow-down-icon') {
        setShowActions(false);
      }
    }

  return (
    <div>
      <img src={ MoreButton } alt="more-options" className="more-options d-block d-lg-none" onClick={ handleShow } />
      <button className="btn rounded-pill w-em-20 btn-success py-3 d-none d-lg-block" onClick={ handleShow } >View Claim</button>

      <Modal id="modal-content" show={ show } onHide={ handleClose } keyboard={ false } size="lg" dialogClassName="modal-70w" centered onClick={(e) => modalClick(e.target) }>
        <Modal.Header>
          <Modal.Title>Claim Details</Modal.Title>

          <span className="float-right position-relative font-size-4">
            <button id="more-actions-btn" className="btn btn-outline-danger rounded-pill px-4 py-2" onClick={() => setShowActions(!showActions) }>
              More Actions
              <img id="arrow-down-icon" src={ ArrowDown } alt="arrow-down" className="ml-3" />
            </button>

            <div id="claim-more-actions" className="conditional-display" displayed={ showActions.toString() }>
              <NavLink className="action-child d-block text-black px-4 py-4" to={ '/eb/print-claim/' + props.data.id } target="_blank" rel="noopener noreferrer">
                Print
              </NavLink>
            </div>
          </span>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body>
          { claimDetailsElements(props) }
        </Modal.Body>
      </Modal>
    </div>
  );
}